var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NotAuthHeader',{attrs:{"simple":""}}),_c('div',{staticClass:"help-layout"},[_c('router-view')],1),_c('Footer',{staticClass:"auth-layout__footer"}),_c('FeedbackModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }